import { memo } from "react";

export const ProductAvailableDetails = memo(function ProductAvailableDetails() {
  return null;
});
